import { Center, Text } from "@chakra-ui/react"
import LazyBox from "../lazy/LazyBox"




const BlankState = ({image , title, description} : {
    image ?: string,
    title : string,
    description : string,
}) => {

    return <>
    <Center w="100%" flexDir="column" gap="12px">
       <LazyBox width={240} height={160}
       src={image ?? "https://placehold.co/382x254"}
       /> 
       <Text fontWeight="500" fontSize="22px">{title}</Text>
        <Text fontWeight="400" fontSize="15px" color="#7E8B9A">{description}</Text>
    </Center>
    </>
}

export default BlankState